import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import "./Article.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const columns = [
  { id: "id", label: "ID", minWidth: 170 },
  { id: "dec", label: "Description", minWidth: 100 },
  {
    id: "edit",
    label: "Edit",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "delete",
    label: "Delete",
    minWidth: 170,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
];

// function createData(name, code, population, size) {
//   const density = population / size;
//   return { name, code, population, size, density };
// }

const useStyles = makeStyles({
  root: {
    width: "85%",
    height: "100vh",
    margin: "0px auto",
  },
  container: {
    maxHeight: 440,
  },
});

const Article = ({ articleData }) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleClick = () => {
    navigate("/siteadmin/add-article");
  };
  const notify = (message) => {
    toast.success(message, {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const handleDelete = (_id) => {
    axios
      .delete(`https://abc-backend.onrender.com/api/articles/${_id}`)
      .then((res) => {
        notify(res.data);
        window.location.reload();
      });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <Paper className={classes.root} style={{ marginTop: "100px" }}>
      <button className="admin_add_btn" onClick={handleClick}>
        Add Article
      </button>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {articleData.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
                  <TableCell>{row._id}</TableCell>
                  <TableCell>{row.desc?.slice(0, 30)}</TableCell>
                  <TableCell style={{ textAlign: "right" }}>
                    <Link to={`/siteadmin/${row._id}`}>
                      <button className="admin_up_btn">Edit</button>
                    </Link>
                  </TableCell>
                  <TableCell style={{ textAlign: "right" }}>
                    <button
                      className="admin_de_btn"
                      onClick={() => handleDelete(row._id)}
                    >
                      Delete
                    </button>
                  </TableCell>
                  {/* {columns.map((column) => {
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {row.desc}
                      </TableCell>
                    );
                  })} */}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
      <ToastContainer />
    </Paper>
  );
};

export default Article;
